<script setup lang="ts">
import { cn } from '@ui/lib/utils.js';
import { AvatarFallback, type AvatarFallbackProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<AvatarFallbackProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <AvatarFallback
        data-slot="avatar-fallback"
        v-bind="delegatedProps"
        :class="
            cn(
                'bg-surface-primary text-foreground-on-primary flex size-full items-center justify-center font-bold leading-none',
                props.class,
            )
        "
    >
        <slot />
    </AvatarFallback>
</template>
